/**
 * Coordinates what happens when the API rejects the session (HTTP 401).
 *
 * A dead session fails every request in flight at once, so the API clients report each 401 here
 * and only the first one starts the expiry flow - one logout, one redirect, one toast. The flow
 * itself is registered by the store (see store.ts), because the API clients cannot import the
 * store without an import cycle (store -> thunks -> services -> API clients).
 */
type SessionExpiredHandler = () => boolean;

let sessionExpiredHandler: SessionExpiredHandler = () => false;
let isSessionExpiring = false;

/** The handler returns false when nobody is signed in, i.e. there was no session to expire. */
export const setSessionExpiredHandler = (handler: SessionExpiredHandler) => {
  sessionExpiredHandler = handler;
};

/**
 * Returns true when the 401 belongs to the expiry flow. The flow ends in a full page reload, so
 * once it has started the latch never needs resetting.
 */
export const reportSessionExpired = (): boolean => {
  if (!isSessionExpiring) {
    isSessionExpiring = sessionExpiredHandler();
  }
  return isSessionExpiring;
};
